webpackJsonp([1,2],Array(26).concat([
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PERSON_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_FAILED; });
var PERSON_CHANGED = 'PERSON_CHANGED';
var API_FAILED = 'API_FAILED';

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component1_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Component1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component2_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Component2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component3_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Component3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NotFoundComponent_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NotFoundComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_NotFoundComponent_vue__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/vuex-demo/',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home_vue___default.a
  }, {
    path: '/component1',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Component1_vue___default.a
  }, {
    path: '/component2',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Component2_vue___default.a
  }, {
    path: '/component3',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Component3_vue___default.a
  }, { path: '*',
    component: __WEBPACK_IMPORTED_MODULE_6__components_NotFoundComponent_vue___default.a
  }]
});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["a"] = {
  savePerson: function savePerson(person) {
    var result = getResult(person);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        if (result instanceof Error) {
          reject(result);
        } else {
          resolve(result);
        }
      }, 1000);
    });
  }
};

var ERROR_PCT = 25.0;
var getResult = function getResult(person) {
  if (Math.random() * 100 <= ERROR_PCT) {
    return new Error('api failed');
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, person);
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(43);




/* harmony default export */ __webpack_exports__["a"] = {

  clearApiError: function clearApiError(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* API_FAILED */], '');
  },
  savePerson2: function savePerson2(_ref2, person) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    dispatch('clearApiError');
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].savePerson(person).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* PERSON_CHANGED */], response);
    }, function (_) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* API_FAILED */], 'Database update failed');
    });
  },
  savePerson3: function savePerson3(_ref3, person) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    dispatch('clearApiError');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].savePerson(person).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* PERSON_CHANGED */], response);
        resolve();
      }, function (_) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* API_FAILED */], 'Database update failed');
        reject();
      });
    });
  }
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(26);


var _types$API_FAILED$typ;



/* harmony default export */ __webpack_exports__["a"] = _types$API_FAILED$typ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$API_FAILED$typ, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* API_FAILED */], function (state, msg) {
  state.apiError = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$API_FAILED$typ, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* PERSON_CHANGED */], function (state, person) {
  state.person = person;
}), _types$API_FAILED$typ;

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(44);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var state = {
  person: {
    name: '',
    profession: ''
  },
  apiError: ''
};

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: state,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VuexView_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VuexView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VuexView_vue__);




/* harmony default export */ __webpack_exports__["default"] = {
  store: __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */],
  name: 'app',
  components: { VuexView: __WEBPACK_IMPORTED_MODULE_1__components_VuexView_vue___default.a }
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['person']))
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      localPerson: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.person)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['person', 'apiError'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    revert: function revert() {
      this.localPerson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.person);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['savePerson2']))
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      localPerson: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.person)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['person', 'apiError'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    revert: function revert() {
      this.localPerson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.person);
    },
    savePerson: function savePerson() {
      return this.savePerson3(this.localPerson);
    },
    saveClosePerson: function saveClosePerson() {
      var _this = this;

      this.savePerson().then(function () {
        return _this.$router.push('/');
      }, function () {});
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['savePerson3']))
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {



/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])([])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([]))
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['person', 'apiError'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([]))
};

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  "data-v-6529fe55",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 left-pane"
  }, [_c('div', {
    staticClass: "col-xs-12 nav-pane"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/component1"
    }
  }, [_vm._v("Component 1")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/component2"
    }
  }, [_vm._v("Component 2")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/component3"
    }
  }, [_vm._v("Component 3")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 component-pane"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 vuex-pane"
  }, [_c('vuex-view')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "Home"
  }, [_c('div', [_vm._v("\n    Please select a page using the menu above\n  ")])])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VuexView"
  }, [_c('h2', {
    staticClass: "std"
  }, [_vm._v("Vuex State")]), _vm._v(" "), _c('div', {
    staticClass: "std"
  }, [_vm._v("{")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "indent2 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("name:")]), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("'" + _vm._s(_vm.person.name) + "'")]), _c('span', {
    staticClass: "punc"
  }, [_vm._v(",")])]), _vm._v(" "), _c('div', {
    staticClass: "indent2 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("profession:")]), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("'" + _vm._s(_vm.person.profession) + "'")])]), _vm._v(" "), _c('div', {
    staticClass: "indent1 std"
  }, [_vm._v("},")]), _vm._v(" "), _c('div', {
    staticClass: "indent1 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("apiError:")]), _vm._v(" "), _c('span', {
    staticClass: "lit"
  }, [_vm._v("'" + _vm._s(_vm.apiError) + "'")])]), _vm._v(" "), _c('div', {
    staticClass: "std"
  }, [_vm._v("}")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indent1 std"
  }, [_c('span', {
    staticClass: "var"
  }, [_vm._v("person")]), _vm._v(": {")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "NotFoundComponent"
  }, [_c('div', [_vm._v("\n    Page not found - please check your URL\n  ")])])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Component1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Your name (1)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.name),
      expression: "person.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.person.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputProfession"
    }
  }, [_vm._v("Your profession (1)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.profession),
      expression: "person.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProfession",
      "placeholder": "Profession"
    },
    domProps: {
      "value": (_vm.person.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.profession = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Component1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Your name (2)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPerson.name),
      expression: "localPerson.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.localPerson.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localPerson.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputProfession"
    }
  }, [_vm._v("Your profession (2)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPerson.profession),
      expression: "localPerson.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProfession",
      "placeholder": "Profession"
    },
    domProps: {
      "value": (_vm.localPerson.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localPerson.profession = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.revert
    }
  }, [_vm._v("Revert")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.savePerson2(_vm.localPerson)
      }
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), (_vm.apiError) ? _c('div', {
    staticClass: "col-sm-offset-3 error"
  }, [_vm._v("\n      " + _vm._s(_vm.apiError) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Component3"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Your name (3)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPerson.name),
      expression: "localPerson.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.localPerson.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localPerson.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputProfession"
    }
  }, [_vm._v("Your profession (3)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPerson.profession),
      expression: "localPerson.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProfession",
      "placeholder": "Profession"
    },
    domProps: {
      "value": (_vm.localPerson.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localPerson.profession = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.revert
    }
  }, [_vm._v("Revert")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveClosePerson
    }
  }, [_vm._v("Save & Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePerson
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), (_vm.apiError) ? _c('div', {
    staticClass: "col-sm-offset-3 error"
  }, [_vm._v("\n      " + _vm._s(_vm.apiError) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(41);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
]),[116]);


// WEBPACK FOOTER //
// static/js/app.681371cee788eaa8b7ab.js